import { useMemo } from "react";
import { localStorageService } from "../utiles/storage";

export function useLoggedInStaffId() {
    const loggedInUserId = useMemo(() => localStorageService.getItem("staffId"), [])

    return {
        staffId: loggedInUserId
    }
}